export default __webpack_public_path__ + "static/media/area-68.ba12afd2.jpg";